import axios from './financeiroApi';

// TODO: utilizar financeiro-api quando endpoint estiver disponível

const PATH = '/api/v1/backend/servico';

const getPath = () => {
  return `/api/v1/backend/servico`;
};

const getParams = (params) => {
  let newParams;
  if (params?.filtroAvancado) {
    newParams = { ...params, ...params.filtroAvancado };
    delete newParams.filtroAvancado;
  } else {
    newParams = params;
  }

  return newParams;
};

const servicoApi = {
  get: (search) => {
    const url = `${getPath()}`;
    return axios.get(url, { params: getParams(search) });
  },
  getOne: (servicoId) => {
    const url = `${PATH}/${servicoId}`;
    return axios.get(url);
  },
  post: (servico) => {
    const url = `${PATH}`;
    return axios.post(url, servico);
  },
  put: (servico, alteracaoFiscal = false, verificacaoFeita = false, idNotificacao) => {
    const url = `${PATH}/${servico.id}?alteracaoFiscal=${alteracaoFiscal}&verificacaoFeita=${verificacaoFeita}&idNotificacao=${idNotificacao}`;
    return axios.put(url, servico);
  },
  delete: (servicoIds, tipoSelecao, query) => {
    const url = `${PATH}?ids=${servicoIds}&q=${query}&tipoSelecao=${tipoSelecao}`;
    return axios.delete(url);
  },
  inactive: (filtro) => {
    const url = `${PATH}/inativar`;
    return axios.patch(url, filtro);
  },
  active: (filtro) => {
    const url = `${PATH}/ativar`;
    return axios.patch(url, filtro);
  },
  pesquisar: (params) => {
    const url = `${PATH}/pesquisar`;
    return axios.get(url, { params });
  },
};

export { servicoApi };
